import { useState, useEffect } from "react";
import Chart from "chart.js/auto";
import { Pie } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import { TextInput, Slider } from "@mantine/core";
import { useForm } from "@mantine/form";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';// import { Tooltip } from "react-tooltip";
Chart.register(CategoryScale);
const Kubera = () => {
        const [isVisible, setIsVisible] = useState(false);
        const handleButtonClick = () => {
          setIsVisible(!isVisible);
       
        };
    const [state, setState] = useState({
        month1: {number:0, value:'', class:''},
        month2: {number:0, value:'', class:''},
        month3: {number:0, value:'', class:''},
        month4: {number:0, value:'', class:''},
        month5: {number:0, value:'', class:''},
        month6: {number:0, value:'', class:''},
        month7: {number:0, value:'', class:''},
        month8: {number:0, value:'', class:''},
        month9: {number:0, value:'', class:''},
        month10: {number:0, value:'', class:''},
        month11: {number:0, value:'', class:''},
        month12: {number:0, value: '', class:''}
    });
    const nbsp = "\xa0";
    const [weight, setWeight ] = useState({
        weight1 : 0,
        weight2: 0,
        weight3: 0,
        weight4: 0,
        weight5: 0,
        weight6:0,
        weight7: 0,
        weight8:0 ,
        weight9: 0,
        weight10: 0,
        weight11: 0
    });
    
    const [totalWt, setTotalWt] = useState(0);

       
    const [users, setUsers] = useState([])

    const fetchUserData = () => {
                fetch("https://apis.bhimagold.com/api_db.js/api/v1//todaysgoldrate")
                .then(response => {
                return response.json()
                })
                .then(data => {
                setUsers(data)
                
                })
    }
        
    var values = JSON.stringify(Object.values(users));
            
    var goldRate:number =0;
    if( values.length > 2 ) {
        var temp = values.split('\",')[1];
        temp = temp.replace( ",", "" );
        temp = temp.replace( "\"", "" )
        goldRate = Number(temp);
        }

    const formatter = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 2,
        });
        const formatter1 = new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR',
                maximumFractionDigits: 0,
            });

    const form = useForm({
            initialValues: {
                    installmentAmt: 10000,
                    numInstallment: 11,
                    makingCharges: 20,
                    accumulatedweight: 5,
                    goldprice:5000,
                    goldweight:3,
            },
            validate: {
                    installmentAmt: (value) => (value <= 2000 ? null : "Amount must be greater than 0"),
            },
    });

    const form1 = useForm({
            initialValues: {
                installmentAmt:2000,
                goldrateMo1:'', 
                goldrateMo2:'',
                goldrateMo3:'',
                goldrateMo4:'',
                goldrateMo5:'',
                goldrateMo6:'',
                goldrateMo7:'',
                goldrateMo8:'',
                goldrateMo9:'',
                goldrateMo10:'',
                goldrateMo11:'',
            },
    });

    const regex =  /^[0-9]{4}$/g;

    function handleChange (e : any) {
        
        let val =  e.target.value.match(regex)
        
        
                if( val != null && val.length > 0 ) {
                let c = formatter.format(val[0])
                setState({ ...state, ["month" + e.target.name]:{number:val[0], value:c, class: ''}});
                setWeight({...weight, ["weight" + e.target.name]: form.values.installmentAmt / val[0]})
                recalcTotal();
                }
                else if( e.target.value.length <= 8 ){
                        
                        if( e.target.value.length == 0 ) {
                                setState({ ...state, ["month" + e.target.name]:{number:1, value:e.target.value, class:'invalid'}});
                                setWeight({...weight, ["weight" + e.target.name]: 0})
                                recalcTotal();
                        }
                        else if( !isNaN( e.target.value) )
                                setState({ ...state, ["month" + e.target.name]:{number:e.target.value, value:e.target.value, class: 'invalid'}});
                        else if( isNaN( e.target.value) )
                                setState({ ...state, ["month" + e.target.name]:{number:1, value:1, class: 'invalid'}});
                        else {
                                let val = e.target.value;
                                val = val.replace( '₹', '');
                                val = val.replace(',','' );
                                val = val.replace('.0', '' )
                                setState({ ...state, ["month" + e.target.name]:{number:val, value:val, class:''}});
                        }
                }
    }
   
        function getNextRate( curRate : number )
        {
                return( Math.trunc(curRate + (curRate * 0.005)));
        }

        const  worth = () => totalWt * (form.values.makingCharges/200);
        const worthinrs = () => worth() * state.month12.number;
        const getjewelworth = () => totalWt+ worth();
       // console.log(worthinrs())
        const getChartData = () => {
                const discount = worth();
                const amount = totalWt;
                const Data = [
                        {
                                label: `Benefit Offered (${discount.toFixed(3)}g)           `,
                                amount: worth(),
                },
                        {
                                label: `Accumulated Weight (${amount.toFixed(3)}g)`,
                                amount: totalWt,
                },
                
                
                ];
                        
                


                return {
                        labels: Data.map((data) => data.label),
                        datasets: [
                                {
                                        data: Data.map((data) => data.amount),
                                        backgroundColor: [ "#f3ba2f", "#4B5320",],
                                        borderColor: "#555",
                                        borderWidth: 2,
                                },
                        ],
                };
        };


        function recalcTotal()
        {
                let total = weight.weight1 + weight.weight2 + weight.weight3 + weight.weight4 
                           + weight.weight5 + weight.weight6 + weight.weight7 + weight.weight8 
                           + weight.weight9 + weight.weight10 + weight.weight11;
                setTotalWt( total );

        }
        const [chartData, setChartData] = useState(getChartData());

        useEffect(() => {
                setChartData(getChartData());
        }, [totalWt, form.values.makingCharges], )

        useEffect(() => {
                recalcTotal();
        },[weight])

        useEffect(() => {

                setWeight({...weight, weight1:form.values.installmentAmt / state.month1.number,
                weight2: form.values.installmentAmt / state.month2.number,
                weight3: form.values.installmentAmt / state.month3.number,
                weight4: form.values.installmentAmt / state.month4.number,
                weight5: form.values.installmentAmt / state.month5.number,
                weight6: form.values.installmentAmt / state.month6.number,
                weight7: form.values.installmentAmt / state.month7.number,
                weight8: form.values.installmentAmt / state.month8.number,
                weight9: form.values.installmentAmt / state.month9.number,
                weight10: form.values.installmentAmt / state.month10.number,
                weight11: form.values.installmentAmt / state.month11.number
          })
          recalcTotal();

        }, [form.values.installmentAmt])

        useEffect(() => {
                setChartData(getChartData());
                fetchUserData();
                if( goldRate > 0 )
                {
                        let total = 0;
               // console.log( goldRate)

                total += form.values.installmentAmt / goldRate;

                let nextRate1 = getNextRate( goldRate );
                total += form.values.installmentAmt / nextRate1;

                let nextRate2 = getNextRate( nextRate1 );
                total += form.values.installmentAmt / nextRate2;

                let nextRate3 = getNextRate( nextRate2 );
                total += form.values.installmentAmt / nextRate3;

                let nextRate4 = getNextRate( nextRate3 );
                total += form.values.installmentAmt / nextRate4;

                let nextRate5 = getNextRate( nextRate4 );
                total += form.values.installmentAmt / nextRate5;

                let nextRate6 = getNextRate( nextRate5 );
                total += form.values.installmentAmt / nextRate6;

                let nextRate7 = getNextRate( nextRate6 );
                total += form.values.installmentAmt / nextRate7;

                let nextRate8 = getNextRate( nextRate7 );
                total += form.values.installmentAmt / nextRate8;

                let nextRate9 = getNextRate( nextRate8 );
                total += form.values.installmentAmt / nextRate9;

                let nextRate10 = getNextRate( nextRate9 );
                total += form.values.installmentAmt / nextRate10;

                let nextRate11 = getNextRate( nextRate10 );
                total += form.values.installmentAmt / nextRate11;
                
                setState({ ...state, ['month9']:{number:nextRate8, value:formatter.format(nextRate8), class:''},
                month11:{number:nextRate10, value:formatter.format(nextRate10), class:''},
                month10:{number:nextRate9, value:formatter.format(nextRate9), class:''},
                month1:{number:goldRate, value:formatter.format(goldRate), class:''},
                month2:{number:nextRate1, value:formatter.format(nextRate1), class:''},
                month3:{number:nextRate2, value:formatter.format(nextRate2), class:''},
                month4:{number:nextRate3, value:formatter.format(nextRate3), class:''},
                month5:{number:nextRate4, value:formatter.format(nextRate4), class:''},
                month6:{number:nextRate5, value:formatter.format(nextRate5), class:''},
                month7:{number:nextRate6, value:formatter.format(nextRate6), class:''},
                month8:{number:nextRate7, value:formatter.format(nextRate7), class:''},
                month12:{number:nextRate11, value:formatter.format(nextRate11), class:''}
        });

                setWeight({...weight, weight1:form.values.installmentAmt / goldRate,
                                      weight2: form.values.installmentAmt / nextRate1,
                                      weight3: form.values.installmentAmt / nextRate2,
                                      weight4: form.values.installmentAmt / nextRate3,
                                      weight5: form.values.installmentAmt / nextRate4,
                                      weight6: form.values.installmentAmt / nextRate5,
                                      weight7: form.values.installmentAmt / nextRate6,
                                      weight8: form.values.installmentAmt / nextRate7,
                                      weight9: form.values.installmentAmt / nextRate8,
                                      weight10: form.values.installmentAmt / nextRate9,
                                      weight11: form.values.installmentAmt / nextRate10
                                })
                setTotalWt( total );
                }
        }, [goldRate, form.values.numInstallment]);


    return (
   
                <div className="page-content">
                        {/* <h1 style={{ color: "#980717", fontStyle: "italic" }}>Kubera Plan</h1> */}
                        <div style={{ display: "flex", gap: "10px" }}>
      <div className="container-fluid">
                                <div className="row">
                                <div className="col-md-4">
                                       
                                <form onSubmit={form.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
                                        
                                <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>Installment Amount</label>
                                                        <div>{formatter1.format(form.values.installmentAmt)
                                                        }</div>
                                                </div>
                                                <Slider {...form.getInputProps("installmentAmt")} min={2000} max={100000} step={1000}/>
                                        </div>
                                                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <label>No. of Installments :</label>
    <div>{form.values.numInstallment}</div>
  </div>
  <div style={{ position: "relative", width: "100%" }}>
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "8px",
        background: "#228be6",
        borderRadius: "5px",
        zIndex: 0,
      }}
    />
    <div
      style={{
        position: "absolute",
        width: "calc(100% * 11 / 11)", // This sets the width to 100% when the value is 11
        height: "8px",
        background: "#228be6",
        borderRadius: "5px",
        zIndex: 1,
      }}
    />
    <input
      type="range"
      min={1}
      max={11}
      step={1}
      value={form.values.numInstallment}
      disabled // Disable the slider interaction
      style={{
        width: "100%",
        height: "8px",
        cursor: "default",
        opacity: 0,
        zIndex: 2,
      }}
    />
  </div>
  {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>Gold Weight in </label>
                                                        <div>{form.values.goldweight}gm</div>
                                                </div>
                                                <Slider {...form.getInputProps("goldweight")} min={minValue} max={maxValue} step={0.001} defaultValue={minValue}/>
                                        </div>   */}
</div>
<div></div>

{/* return (
    <div>
     
        <ul>
          {users.gold22k}
        </ul>
      
    </div>
  ); */}
 <div>
      
    </div>
                    
                                        <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <label>Net Making Charges:</label>
                                                        <div>{form.values.makingCharges}%</div>
                                                </div>
                                                <Slider {...form.getInputProps("makingCharges")} min={2} max={40} />
                                        </div>
                                        
                                </form> 
                                                
                                 <br></br>
                                </div>
                                <br></br>
                                <div className="col-md-5">

<table className="table table-striped ">
<thead>
{/* <Tr>
<Td>Total Amount Paid:</Td>
<Td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></Td>

</Tr> */}
<tr>
<td>Total Accumulated Weight:</td>
<td> <div className="bold" style={{ textAlign: "right" }}>{totalWt.toFixed(3)}g</div></td>

</tr>
</thead>
<tbody>

<tr>
<td>Benefit Offered:</td>
<td> <div className="bold" style={{ textAlign: "right" }}>{worth().toFixed(3)}g</div></td>
</tr>
<tr><td>Redemption Weight:</td>
 <td><div className="bold" style={{ textAlign: "right" }}>{getjewelworth().toFixed(3)}g</div></td></tr>


</tbody>
</table>



        
        <div className="card">
<div className="card-body">
<b>Benefit:</b> <br></br>
{/* No need to pay Making charges<b>{formatter.format(getDiscount())}</b>  on product worth <b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b>
{' '} (Effectively you got benefit worth <b>{formatter.format(getDiscount())}</b> in this case) */}
You need to <b>pay only 50% of Making charges</b> on Product (s) weighing <b>{totalWt.toFixed(3)}g</b> (Effectively you get benefit worth <b>{worth().toFixed(3)}g of 22Kt Gold</b> in this example)


</div>


</div>




        {/* <div>
                <label>You would effectively pay</label>
                <div className="bold">{form.values.installmentAmt * form.values.numInstallment}</div>
        </div> */}

<br></br>     

</div>
                                <div className="col-md-3">
                                        <Pie data={chartData} />
                                
                                </div>
                        </div>
<br></br>
<BrowserView>
<div className="row indicator">
					<div className="col-md-3"></div>
					<div className="col-md-6">
                                                <p className="calculatorFor">
                                                        <a href="/?scheme_name=golden-key&show_menu=0&show_title=0" className="previous round">&#8592;</a> Sample Calculator For <b className="jppName">Kubera </b>
                                                        <a href="/?scheme_name=samruddhi&show_menu=0&show_title=0" className="next round">&#8594;</a></p>  </div>
					<div className="col-md-3"><div className="card-body" style={{ textAlign:'center'}}><br></br>For more details contact Bhima Helpline <a href="tel:1800-121-9076">1800-121-9076</a>
				</div></div>
				</div>
                                </BrowserView>
                                <MobileView>
				<div className="row indicator">
					<div className="col-md-3"></div>
					<div className="col-md-6"><p className="calculatorFor"> Sample Calculator For <b className="jppName">Kubera </b></p>  </div>
					<div className="col-md-3"></div>
				</div>
				<div className="row indicator">
					<div className="col-md-5"></div>
					<div className="col-md-2" style={{textAlign:"center"}}><a href="/?scheme_name=golden-key&show_menu=0&show_title=0" className="previous round">&#8592;</a>{nbsp}{nbsp}{nbsp}

                                        <a href="/?scheme_name=samruddhi&show_menu=0&show_title=0" className="next round">&#8594;</a></div>	
<div className="col-md-5"><div className="card-body" style={{ textAlign:'center'}}><br></br>For more details contact Bhima Helpline <a href="tel:1800-121-9076">1800-121-9076</a>
				</div></div>
				</div>
				</MobileView>
                                <br></br>
             
        <button onClick={handleButtonClick} type="button" className="btn" style={{background:'#f79b7c'}}>{isVisible ? 'View Less..' : 'View More..'}</button>
                
                                  

      {isVisible && <div>  <br></br> <div className="row">
                        <form onSubmit={form1.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
<Table className="table-responsive-sm table-bordered table table-striped">
<Thead className="thead-dark">
<Tr>
<Td><b>No. of Inst.</b></Td>
<Td><b>Inst. Amount</b></Td>
<Td><b>Gold Rate*</b></Td>
<Td><b>Gold Wt. Credit</b></Td>
</Tr>
</Thead>
<Tbody>
<Tr><Td>1 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
{/* <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td> */}
<Td><TextInput onChange={handleChange} value={state.month1.value} name='1' size="xs"/>
{state.month1.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight1.toFixed(3)} g</Td></Tr>
<Tr><Td>2 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month2.value} name='2' size="xs"/>
{state.month2.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight2.toFixed(3)} g</Td></Tr>
<Tr><Td>3 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput  onChange={handleChange} value={state.month3.value}  name='3' size="xs"/>
{state.month3.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight3.toFixed(3)} g</Td></Tr>
<Tr><Td>4 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month4.value}  name='4' size="xs"/>
{state.month4.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight4.toFixed(3)} g</Td></Tr>
<Tr><Td>5 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput  onChange={handleChange} value={state.month5.value}  name='5' size="xs"/>
{state.month5.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight5.toFixed(3)} g</Td></Tr>
<Tr><Td>6 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month6.value}  name='6' size="xs"/>
{state.month6.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight6.toFixed(3)} g</Td></Tr>
<Tr><Td>7</Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month7.value} name='7' size="xs"/>
{state.month7.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight7.toFixed(3)} g</Td></Tr>
<Tr><Td>8 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month8.value} name='8' size="xs"/>
{state.month8.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight8.toFixed(3)} g</Td></Tr>
<Tr><Td>9</Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month9.value}  name='9' size="xs"/>
{state.month9.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight9.toFixed(3)} g</Td></Tr>
<Tr><Td>10 </Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month10.value}  name='10' size="xs"/>
{state.month10.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight10.toFixed(3)} g</Td></Tr>
<Tr><Td>11</Td>
<Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
<Td><TextInput onChange={handleChange} value={state.month11.value} name='11' size="xs"/>
{state.month11.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} </Td>
<Td >{weight.weight11.toFixed(3)} g</Td></Tr>
<Tr>
<Td><b>Total</b></Td>
<Td><b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b></Td>
<Td  style={{ textAlign :'right'}}>
        {/* Total Accumulated Wt. in grams */}
        </Td>
<Td><b>{totalWt.toFixed(3)} g</b></Td>
</Tr>
</Tbody>

</Table>
</form>

</div><div className="card">
                <div className="card-body">
<div className="row"> 
<div className="col-md-3"> Assumed gold rate on the day of Redemption</div>
<div className="col-md-4"> <TextInput onChange={handleChange} value={state.month12.value} name='12' />
{state.month12.class == 'invalid' ? <div style={{color: "red"}}>*Invalid input</div>: ''} 
</div>
<div className="col-md-2"></div>
<div className="col-md-3"><b>You get benefit worth: {formatter.format(worthinrs())} </b> </div>
        
</div>

                </div>
                </div>
                <br></br>
Gold Rate* : Gold Rate on the day of payment,

Inst. : Installment ,
Wt. : Weight</div>}                      
    
<br></br>



              </div>
                </div>
                </div>
        );
};

export default Kubera;



// import { useState, useEffect } from "react";
// import Chart from "chart.js/auto";
// import { Pie } from "react-chartjs-2";
// import { CategoryScale } from "chart.js";
// import { TextInput, Slider } from "@mantine/core";
// import { useForm } from "@mantine/form";
//  import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//  import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
// // import { Tooltip } from "react-tooltip";
// Chart.register(CategoryScale);
// const Kubera = () => {
//         const [value, setValue] = useState("yes");
//        const formatter = new Intl.NumberFormat('en-IN', {
//                 style: 'currency',
//                 currency: 'INR',
//                 maximumFractionDigits: 2,
//           });
//           const formatter1 = new Intl.NumberFormat('en-IN', {
//                 style: 'currency',
//                 currency: 'INR',
//                 maximumFractionDigits: 0,
//           });

 

  
//         const form = useForm({
//                 initialValues: {
//                         installmentAmt: 10000,
//                         numInstallment: 11,
//             makingCharges: 40,
//             accumulatedweight: 5,
//             goldprice:5000,
//             goldweight:3,
//                 },

//                 validate: {
//                         installmentAmt: (value) => (value <= 2000 ? null : "Amount must be greater than 0"),
//                 },
//         });

//         const form1 = useForm({
//             initialValues: {
//                 installmentAmt:2000,
//                 goldrateMo1:5300, 
//                 goldrateMo2:5335,
//                 goldrateMo3:5389,
//                 goldrateMo4:5400,
//                 goldrateMo5:5489,
//                 goldrateMo6:5449,
//                 goldrateMo7:5649,
//                 goldrateMo8:5650,
//                 goldrateMo9:5325,
//                 goldrateMo10:5360,
//                 goldrateMo11:5399,

//             },
       
           
//     });

//     const form2 = useForm({
//         initialValues: {
//         RedeemAmt:5500,
            

//         },
   
       
// });
// //     const onKeyPress = (event:any) => {
// //         if (!event.key.match(/[0-9]{4}/)) {
// //           event.preventDefault();
// //         //   alert("it should be 4 digit number")
// //         }
// //       };

//         var result = (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges ) / 100
//        // console.log(result);
//         const getDiscount = () => {
        
//         if (form.values.numInstallment === 11){
//             return (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges / 2) / 100;
//         }
//                 if (form.values.numInstallment < 7) {
//                         return 0;
//                 } else 
//                 if (form.values.numInstallment === 7){
//                         return result * 10 / 100;
//                 }
//                 else
//                 if(form.values.numInstallment === 8){
//                         return result * 20 / 100;
//                 }
//                 else if(form.values.numInstallment === 9){
//                         return result * 30 / 100;
//                 }
//                 else if(form.values.numInstallment === 10){
//                         return result * 40 / 100;
//                 }
//                 else
                
//                         {
//                                 return (form.values.installmentAmt * 1);
//                         }
                
//         };
//         const getweightgrid1 =() => (form.values.installmentAmt) / form1.values.goldrateMo1;
//         const getweightgrid2 =() => (form.values.installmentAmt) / form1.values.goldrateMo2;
//         const getweightgrid3 =() => (form.values.installmentAmt) / form1.values.goldrateMo3;
//         const getweightgrid4 =() => (form.values.installmentAmt) / form1.values.goldrateMo4;
//         const getweightgrid5 =() => (form.values.installmentAmt) / form1.values.goldrateMo5;
//         const getweightgrid6 =() => (form.values.installmentAmt) / form1.values.goldrateMo6;
//         const getweightgrid7 =() => (form.values.installmentAmt) / form1.values.goldrateMo7;
//         const getweightgrid8 =() => (form.values.installmentAmt) / form1.values.goldrateMo8;
//         const getweightgrid9 =() => (form.values.installmentAmt) / form1.values.goldrateMo9;
//         const getweightgrid10 =() => (form.values.installmentAmt) / form1.values.goldrateMo10;
//         const getweightgrid11 =() => (form.values.installmentAmt) / form1.values.goldrateMo11;
// const getTotalWeight =() => getweightgrid1()+getweightgrid2()+getweightgrid3()+getweightgrid4()+getweightgrid5()+getweightgrid6()+getweightgrid7()+getweightgrid8()+getweightgrid9()+getweightgrid10()+getweightgrid11();

//         const getTotal =() => form.values.installmentAmt * form.values.numInstallment;
      
//                 const getDiscountPerc = () =>  Math.trunc(getDiscount() / getWorth() * 100);
//         const getROI = () =>  Math.trunc(getDiscount() / (form.values.installmentAmt * form.values.numInstallment)) * 100;
//         const getWorth = () => getDiscount() + form.values.installmentAmt * form.values.numInstallment;
//     const getweight =() => (form.values.installmentAmt * form.values.numInstallment) / form.values.goldprice
// const minValue = getTotal()/(form.values.goldprice*1.10);
// const maxValue = getTotal()/(form.values.goldprice*0.75);
// const  worth = () => getTotalWeight() * (form.values.makingCharges/200)
// const worthinrs =() => worth() * (form2.values.RedeemAmt);
// const getjewelworth = () => getTotalWeight()+ worth();
// //const roundedNumber1 = Math.round(worth());
// var roundedNumber2 : any = worth().toFixed(3);
// var roundedNumber3 : any = getTotalWeight().toFixed(3);
// console.log(roundedNumber3)

//     //const val
//     const getChartData = () => {
//         const discount = worth();
//         const amount = getTotalWeight();
//         const Data = [
//                 {
//                         label: `Benefit Offered (${discount.toFixed(3)}g)           `,
//                         amount: worth(),
//           },
//                 {
//                         label: `Accumulated Weight (${amount.toFixed(3)}g)`,
//                         amount: getTotalWeight(),
//           },
          
          
//         ];
                
        


//         return {
//                 labels: Data.map((data) => data.label),
//                 datasets: [
//                         {
//                                 data: Data.map((data) => data.amount),
//                                 backgroundColor: ["#f3ba2f", "#4B5320"],
//                                 borderColor: "#555",
//                                 borderWidth: 2,
//                         },
//                 ],
//         };
// };

// const [chartData, setChartData] = useState(getChartData());

// useEffect(() => {
//         setChartData(getChartData());
//         //fetchUserData();

// }, [form.values.installmentAmt, form.values.makingCharges, form.values.numInstallment, form1.values.goldrateMo1, form1.values.goldrateMo2, form1.values.goldrateMo3, form1.values.goldrateMo4, form1.values.goldrateMo5,form1.values.goldrateMo6,form1.values.goldrateMo7,form1.values.goldrateMo8,form1.values.goldrateMo9,form1.values.goldrateMo10,form1.values.goldrateMo11]);
//     return (
   
//                 <div className="page-content">
                    
//                         <div style={{ display: "flex", gap: "10px" }}>
//       <div className="container-fluid">
//                                 <div className="row">
//                                 <div className="col-md-4">
                                       
//                                 <form onSubmit={form.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
                                        
//                                 <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Installment Amount</label>
//                                                         <div>{formatter1.format(form.values.installmentAmt)
//                                                         }</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("installmentAmt")} min={2000} max={100000} step={1000}/>
//                                         </div>
                               
//     {/* <div>
//  Today's Gold Rate:   {goldRate}
//         </div> */}

//                     {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Gold Rate:</label>
//                                                         <div>{formatter.format(form.values.goldprice)}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("goldprice")} min={5000} max={7500} />
//                                         </div> */}

                                                                       
//                     {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>No. of Installments:</label>
//                                                         <div>{form.values.numInstallment}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("numInstallment")} min={1} max={11} />
//                                         </div> */}
//                                                                                 <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//   <div style={{ display: "flex", justifyContent: "space-between" }}>
//     <label>No. of Installments :</label>
//     <div>{form.values.numInstallment}</div>
//   </div>
//   <div style={{ position: "relative", width: "100%" }}>
//     <div
//       style={{
//         position: "absolute",
//         width: "100%",
//         height: "8px",
//         background: "#228be6",
//         borderRadius: "5px",
//         zIndex: 0,
//       }}
//     />
//     <div
//       style={{
//         position: "absolute",
//         width: "calc(100% * 11 / 11)", // This sets the width to 100% when the value is 11
//         height: "8px",
//         background: "#228be6",
//         borderRadius: "5px",
//         zIndex: 1,
//       }}
//     />
//     <input
//       type="range"
//       min={1}
//       max={11}
//       step={1}
//       value={form.values.numInstallment}
//       disabled // Disable the slider interaction
//       style={{
//         width: "100%",
//         height: "8px",
//         cursor: "default",
//         opacity: 0,
//         zIndex: 2,
//       }}
//     />
//   </div>
//   {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Gold Weight in </label>
//                                                         <div>{form.values.goldweight}gm</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("goldweight")} min={minValue} max={maxValue} step={0.001} defaultValue={minValue}/>
//                                         </div>   */}
// </div>
// <div></div>

// {/* return (
//     <div>
     
//         <ul>
//           {users.gold22k}
//         </ul>
      
//     </div>
//   ); */}

                    
//                                         <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Net Making Charges:</label>
//                                                         <div>{form.values.makingCharges}%</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("makingCharges")} min={2} max={40} />
//                                         </div>
                                        
//                                 </form> 
                                                
//                                  <br></br>
//                                 </div>
//                                 <br></br>
//                                 <div className="col-md-5">

// <table className="table table-striped ">
// <thead>
// {/* <Tr>
// <Td>Total Amount Paid:</Td>
// <Td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></Td>

// </Tr> */}
// <tr>
// <td>Total Accumulated Weight:</td>
// <td> <div className="bold" style={{ textAlign: "right" }}>{getTotalWeight().toFixed(3)}g</div></td>

// </tr>
// </thead>
// <tbody>

// <tr>
// <td>Benefit Offered:</td>
// <td> <div className="bold" style={{ textAlign: "right" }}>{worth().toFixed(3)}g</div></td>
// </tr>

// <tr>
// <td>Redemption Weight:</td>
// <td><div className="bold" style={{ textAlign: "right" }}>{getjewelworth().toFixed(3)}g</div></td>
// </tr>

// </tbody>
// </table>



        
//         <div className="card">
// <div className="card-body">
// <b>Benefit:</b> <br></br>
// {/* No need to pay Making charges<b>{formatter.format(getDiscount())}</b>  on product worth <b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b>
// {' '} (Effectively you got benefit worth <b>{formatter.format(getDiscount())}</b> in this case) */}
// You need to <b>pay only 50% of Making charges</b> on Product(s) weighing <b>{getTotalWeight().toFixed(3)}g</b> (Effectively you get benefit worth <b>{worth().toFixed(3)}g of 22Kt Gold</b> in this case)


// </div>

// </div>




//         {/* <div>
//                 <label>You would effectively pay</label>
//                 <div className="bold">{form.values.installmentAmt * form.values.numInstallment}</div>
//         </div> */}

// <br></br>     
      
// </div>
//                                 <div className="col-md-3">
//                                 <Pie data={chartData} height={128} width={128}/>
                                
//                                 </div>
//                         </div>
// <br></br>
{/* <div className="accordion" id="accordionExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        Click here for More Details..
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div className="accordion-body">
      <div className="row"> */}

// <form onSubmit={form1.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
// <Table className="table-responsive-sm table-bordered table table-striped">
// <Thead className="thead-dark">
// <Tr>
// <Td><b>No. of Inst.</b></Td>
// <Td><b>Inst. Amount</b></Td>
// <Td><b>Gold Rate*</b></Td>
// <Td><b>Gold Wt. Credit</b></Td>
// </Tr>
// </Thead>
// <Tbody>
// <Tr><Td>1 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td ><TextInput maxLength={4} className="textinput" {...form1.getInputProps("goldrateMo1")}  size="xs"/></Td>
// <Td className="grid">{getweightgrid1().toFixed(3)}</Td></Tr>
// <Tr><Td>2 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo2")} size="xs"/></Td>
// <Td className="grid">{getweightgrid2().toFixed(3)}</Td></Tr> 
// <Tr><Td>3 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo3")} size="xs" /></Td>
// <Td className="grid">{getweightgrid3().toFixed(3)}</Td></Tr>
// <Tr><Td>4 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo4")} size="xs" /></Td>
// <Td className="grid">{getweightgrid4().toFixed(3)}</Td></Tr>
// <Tr><Td>5 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo5")} size="xs" /></Td>
// <Td className="grid">{getweightgrid5().toFixed(3)}</Td></Tr>
// <Tr><Td>6 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo6")} size="xs" /></Td>
// <Td className="grid">{getweightgrid6().toFixed(3)}</Td></Tr>
// <Tr><Td>7</Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo7")} size="xs" /></Td>
// <Td className="grid">{getweightgrid7().toFixed(3)}</Td></Tr>
// <Tr><Td>8 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo8")} size="xs" /></Td>
// <Td className="grid">{getweightgrid8().toFixed(3)}</Td></Tr>
// <Tr><Td>9</Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo9")} size="xs" /></Td>
// <Td className="grid">{getweightgrid9().toFixed(3)}</Td></Tr>
// <Tr><Td>10 </Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo10")} size="xs" /></Td>
// <Td className="grid">{getweightgrid10().toFixed(3)}</Td></Tr>
// <Tr><Td>11</Td>
// <Td><div>{formatter.format(form.values.installmentAmt)}</div></Td>
// <Td><TextInput maxLength={4}  {...form1.getInputProps("goldrateMo11")} size="xs" /></Td>
// <Td className="grid">{getweightgrid11().toFixed(3)}</Td></Tr>
// <Tr>
// <Td ><b>Total</b></Td>
// <Td ><b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b></Td>
// <Td className="grid" style={{ textAlign :'right'}}>
// {/* Total Accumulated Wt. in grams */}
// </Td>
// <Td className="grid" >{getTotalWeight().toFixed(3)}g</Td>
// </Tr>
// </Tbody>

// </Table>
// </form>
// </div>
// <div className="card">
//                  <div className="card-body">
//  <div className="row"> 
//  <div className="col-md-3"> Assumed gold rate on the day of Redemption</div>
//  <div className="col-md-4">  
//  <form onSubmit={form2.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
        
//  <TextInput maxLength={4}  {...form2.getInputProps("RedeemAmt")}  />
//         </form>
// </div>
// <div className="col-md-2"></div>
// <div className="col-md-3"><b>You get benefit worth: {formatter.format(worthinrs())} </b> </div>
        
// </div>
// </div>
// </div>



// Gold Rate* : Gold Rate on the day of payment,
// Inst. : Installment ,
// Wt. : Weight
//       </div>
//     </div>
//   </div>
//   </div>
  
//         <br></br>




//                 </div>
//                 </div>
//                 </div>
//         );
// };

// export default Kubera;


// import { useState, useEffect } from "react";
// import Chart from "chart.js/auto";
// import { Pie } from "react-chartjs-2";
// import { CategoryScale } from "chart.js";
// import { TextInput, Slider } from "@mantine/core";
// import { useForm } from "@mantine/form";

// Chart.register(CategoryScale);
// const Kuberaold = () => {
//         const [value, setValue] = useState("yes");
//         const [users, setUsers] = useState([])

//         const fetchUserData = () => {
//           fetch("http://webapis.bhimagold.com/api_db.js/api/v1//todaysgoldrate")
//             .then(response => {
//               return response.json()
//             })
//             .then(data => {
//               setUsers(data)
              
//             })
//         }

//         var values = JSON.stringify(Object.values(users));
        
// let goldRate = 0;
// if( values.length > 2 ) {
//     var temp = values.split('\",')[1];
//     temp = temp.replace( ",", "" );
//     temp = temp.replace( "\"", "" )
//     goldRate = Number(temp);
//     console.log(goldRate*10)
// }
// //console.log(Object.values(users));
//         const formatter = new Intl.NumberFormat('en-IN', {
// 		style: 'currency',
// 		currency: 'INR',
// 		maximumFractionDigits: 2,
// 	  });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setValue(e.target.value);
//   };

  
//         const form = useForm({
//                 initialValues: {
//                         installmentAmt: 5000,
//                         numInstallment: 11,
//             makingCharges: 40,
//             accumulatedweight: 5,
//             goldprice:5000,
//             goldweight:9.5,
//                 },

//                 validate: {
//                         installmentAmt: (value) => (value <= 2000 ? null : "Amount must be greater than 0"),
//                 },
//         });

//         var result = (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges ) / 100
//        // console.log(result);
//         const getDiscount = () => {
        
//         if (form.values.numInstallment === 11){
//             return (form.values.installmentAmt * form.values.numInstallment * form.values.makingCharges / 2) / 100;
//         }
//                 if (form.values.numInstallment < 7) {
//                         return 0;
//                 } else 
//                 if (form.values.numInstallment === 7){
//                         return result * 10 / 100;
//                 }
//                 else
//                 if(form.values.numInstallment === 8){
//                         return result * 20 / 100;
//                 }
//                 else if(form.values.numInstallment === 9){
//                         return result * 30 / 100;
//                 }
//                 else if(form.values.numInstallment === 10){
//                         return result * 40 / 100;
//                 }
//                 else
                
//                         {
//                                 return (form.values.installmentAmt * 1);
//                         }
                
//         };
//         const getTotal =() => form.values.installmentAmt * form.values.numInstallment;
//         const getDiscountPerc = () =>  Math.trunc(getDiscount() / getWorth() * 100);
//         const getROI = () =>  Math.trunc(getDiscount() / (form.values.installmentAmt * form.values.numInstallment)) * 100;
//         const getWorth = () => getDiscount() + form.values.installmentAmt * form.values.numInstallment;
//     const getweight =() => (form.values.installmentAmt * form.values.numInstallment) / goldRate
// const minValue = getTotal()/(goldRate*1.10);
// const maxValue = getTotal()/(goldRate*0.75);

//     //const val
//     const getChartData = () => {
//         const discount = getDiscount();
//         const amount = getTotal();
//         const Data = [
//                 {
//                         label: `Benefit Offered (${formatter.format(discount)})`,
//                         amount: getDiscount(),
//           },
//                 {
//                         label: `Amount Paid (${formatter.format(amount)})`,
//                         amount: getTotal(),
//           },
          
          
//         ];
                
        


//         return {
//                 labels: Data.map((data) => data.label),
//                 datasets: [
//                         {
//                                 data: Data.map((data) => data.amount),
//                                 backgroundColor: ["#f3ba2f", "#2a71d0"],
//                                 borderColor: "#555",
//                                 borderWidth: 2,
//                         },
//                 ],
//         };
// };

// const [chartData, setChartData] = useState(getChartData());

// useEffect(() => {
//         setChartData(getChartData());
//         fetchUserData();

// }, [form.values.installmentAmt, form.values.makingCharges, form.values.numInstallment]);
//     return (
   
//                 <div className="page-content">
//                         {/* <h1 style={{ color: "#980717", fontStyle: "italic" }}>Kubera Plan</h1> */}
//                         <div style={{ display: "flex", gap: "10px" }}>
//       <div className="container-fluid">
//                                 <div className="row">
//                                 <div className="col-md-4">
                                       
//                                 <form onSubmit={form.onSubmit((values) => console.log(values))} style={{ flex: 1 }}>
                                        
//                                 <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Installment Amount</label>
//                                                         <div>{formatter.format(form.values.installmentAmt)}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("installmentAmt")} min={5000} max={1000000} step={1000}/>
//                                         </div>
                               
//     <div>
//  Today's Gold Rate:   {goldRate}
// 	</div>

//                     {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Gold Rate:</label>
//                                                         <div>{formatter.format(form.values.goldprice)}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("goldprice")} min={5000} max={7500} />
//                                         </div> */}

                                                                       
//                     {/* <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>No. of Installments:</label>
//                                                         <div>{form.values.numInstallment}</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("numInstallment")} min={1} max={11} />
//                                         </div> */}
// 										<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//   <div style={{ display: "flex", justifyContent: "space-between" }}>
//     <label>No. of Installments :</label>
//     <div>{form.values.numInstallment}</div>
//   </div>
//   <div style={{ position: "relative", width: "100%" }}>
//     <div
//       style={{
//         position: "absolute",
//         width: "100%",
//         height: "8px",
//         background: "#ccc",
//         borderRadius: "5px",
//         zIndex: 0,
//       }}
//     />
//     <div
//       style={{
//         position: "absolute",
//         width: "calc(100% * 11 / 11)", // This sets the width to 100% when the value is 11
//         height: "8px",
//         background: "#2a71d0",
//         borderRadius: "5px",
//         zIndex: 1,
//       }}
//     />
//     <input
//       type="range"
//       min={1}
//       max={11}
//       step={1}
//       value={form.values.numInstallment}
//       disabled // Disable the slider interaction
//       style={{
//         width: "100%",
//         height: "8px",
//         cursor: "default",
//         opacity: 0,
//         zIndex: 2,
//       }}
//     />
//   </div>
//   <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Gold Weight in gms</label>
//                                                         <div>{form.values.goldweight}gm</div>
//                                                 </div>


                                                
//                                                 <Slider {...form.getInputProps("goldweight")} min={minValue} max={maxValue} step={0.001} defaultValue={minValue}/>
//                                         </div>  
// </div>
// <div></div>

// {/* return (
//     <div>
     
//         <ul>
//           {users.gold22k}
//         </ul>
      
//     </div>
//   ); */}

                    
//                                         <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
//                                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                                         <label>Making Charges:</label>
//                                                         <div>{form.values.makingCharges}%</div>
//                                                 </div>
//                                                 <Slider {...form.getInputProps("makingCharges")} min={2} max={40} />
//                                         </div>
                                        
//                                 </form>  <br></br>
//                                 </div>
//                                 <br></br>
//                                 <div className="col-md-5">

// <table className="table table-striped">
// <thead>
// <Tr>
// <Td>Total Amount Paid:</Td>
// <Td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></Td>

// </Tr>
// </thead>
// <tbody>
// <Tr>
// <Td>Total Accumulated Weight:</Td>
// <Td> <div className="bold" style={{ textAlign: "right" }}>{getweight().toFixed(3) }gms</div></Td>

// </Tr>
// <Tr>
// <Td>Total Benefit Offered:</Td>
// <Td> <div className="bold" style={{ textAlign: "right" }}>{formatter.format(getDiscount())}</div></Td>
// </Tr>

// <Tr>
// <Td>Get Jewellery Worth:</Td>
// <Td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(getWorth())}</div></Td>
// </Tr>

// </tbody>
// </table>



        
//         <div className="card">
// <div className="card-body">
// <b>Benefit:</b> <br></br>
// No need to pay Making charges<b>{formatter.format(getDiscount())}</b>  on product worth <b>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</b>
// {' '} (Effectively you got benefit worth <b>{formatter.format(getDiscount())}</b> in this case)


// </div>

// </div>

//         {/* <div>
//                 <label>You would effectively pay</label>
//                 <div className="bold">{form.values.installmentAmt * form.values.numInstallment}</div>
//         </div> */}

// <br></br>     
      
// </div>
//                                 <div className="col-md-3">
//                                         <Pie data={chartData} />
                                
//                                 </div>
//                         </div>
//                 </div>
//                 </div>
//                 </div>
//         );
// };

// export default Kuberaold;
